import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'
import XLSX from 'xlsx'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import DeleteModal from 'pages/parts/DeleteModal'

import { formatDate, regexLogin, regexPhoneNumber, returnSign, formatMoney, formatMoneyInput, PAGE_SIZES, findKeyFromArrayByValue } from 'helpers/helpers'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { hasPermission } from 'helpers/permissions'
import { renderSortIndicator } from 'helpers/tableSortIndicator'
import { parseProductTableOrderBy, buildProductTableOrderBy } from 'helpers/productFilterParams'
// Размер страницы истории начисления бонусов в модалке
const BONUS_HISTORY_PAGE_SIZE = 20

function Index() {
	const { t } = useTranslation()

	const partnerStatuses = [
		{ id: 1, name: t('active') },
		{ id: -1, name: t('deleted') },
	]

	const [selectedItem, setSelectedItem] = useState({
		'login': '',
		'phone': '',
		'password': '',
	})
	const [partnersHelper, setPartnersHelper] = useState([])
	const [data, setData] = useState([])
	const [payments, setPayments] = useState([])
	const [bonusHistories, setBonusHistories] = useState([])
	const [bonusHistoryPagination, setBonusHistoryPagination] = useState({
		url: '/admin/partner-bonus-histories',
		response: null,
		size: BONUS_HISTORY_PAGE_SIZE,
	})
	const [modalUser, setModalUser] = useState(false)
	const [modalPayment, setModalPayment] = useState(false)
	const [modalBonus, setModalBonus] = useState(false)
	const [modalBonusWriteOff, setModalBonusWriteOff] = useState(false)
	const [modalPaymentHistory, setModalPaymentHistory] = useState(false)
	const [modalBonusHistory, setModalBonusHistory] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		setFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetToInitialFilters,
	} = useFilterSearchPagination({
		initialFilterData: { 'role': 'ROLE_PARTNER', 'search': '', 'status': 1, 'page': null, 'size': 20 },
		initialPagination: {
			url: '/admin/partners',
			size: 20,
			response: null
		},
	})

	// Параметры отбора — общие для списка и выгрузки в Excel
	function buildFilterParams(currentFilterData) {
		var urlParams = ""
		if (currentFilterData.status)
			urlParams += returnSign(urlParams) + 'status=' + currentFilterData.status
		if (currentFilterData.order_by)
			urlParams += returnSign(urlParams) + 'order_by=' + currentFilterData.order_by
		if (currentFilterData.search)
			urlParams += returnSign(urlParams) + 'search=' + currentFilterData.search
		if (currentFilterData.balance_positive)
			urlParams += returnSign(urlParams) + 'balance_positive=1'
		if (currentFilterData.has_card)
			urlParams += returnSign(urlParams) + 'has_card=1'
		return urlParams
	}

	async function searchWithFilter(nextFilterData = filterData) {
		var filterDataCopy = { ...nextFilterData }
		var filterUrl = "/admin/partners"
		checkFilter(filterDataCopy)

		var urlParams = buildFilterParams(filterDataCopy)
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({
				...pagination,
				url: filterUrl,
				size: filterDataCopy.size,
				response: response.data,
			})
		}

		setDropdownIsOpen(false)
	}

	// Выгрузка в Excel всех партнёров под текущим фильтром, а не только видимой страницы
	async function downloadExcel() {
		var urlParams = buildFilterParams(filterData)
		urlParams += returnSign(urlParams) + 'size=100000'

		const response = await GET('/admin/partners' + urlParams, {}, { loader: true })
		if (!httpOk(response)) return

		const rows = [['Имя', 'Телефон', 'Номер карты', 'Баланс']]
		let totalBalance = 0
		for (const item of response.data?.data || []) {
			const balance = Number(item.partner_balance ?? 0)
			totalBalance += balance
			rows.push([
				item.first_name || '',
				item.phone ? String(item.phone) : '',
				item.card_number ? String(item.card_number) : '',
				balance,
			])
		}
		rows.push(['Итого', '', '', totalBalance])

		const ws = XLSX.utils.aoa_to_sheet(rows)
		ws['!cols'] = [{ wch: 30 }, { wch: 16 }, { wch: 24 }, { wch: 14 }]
		const wb = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(wb, ws, 'Партнёры')
		XLSX.writeFile(wb, `Партнёры ${formatDate(new Date(), 'dd.MM.yyyy')}.xlsx`)
	}

	async function createUpdate(e) {
		e.preventDefault();
		var selectedItemCopy = { ...selectedItem }

		if (selectedItemCopy.phone && String(selectedItemCopy.phone).length === 9)
			selectedItemCopy.phone = '998' + selectedItemCopy.phone

		var response
		if (!selectedItemCopy.id) {
			response = await POST('/admin/users/partner', selectedItemCopy)
		} else {
			response = await PUT('/admin/users/partner', selectedItemCopy)
		}

		if (httpOk(response)) {
			toggleModal(false)
			searchWithFilter()
		}
	}

	async function partnerPayment(e) {
		e.preventDefault();

		var response = await POST('/admin/partner-payment', selectedItem, { loader: true })
		if (httpOk(response)) {
			setSelectedItem({})
			setModalPayment(false)
			searchWithFilter()
		}
	}

	async function partnerBonus(e) {
		e.preventDefault();

		var response = await POST('/admin/partner-bonus', selectedItem, { loader: true })
		if (httpOk(response)) {
			setSelectedItem({})
			setModalBonus(false)
			searchWithFilter()
		}
	}

	async function partnerBonusWriteOff(e) {
		e.preventDefault();

		var response = await POST('/admin/partner-bonus-write-off', selectedItem, { loader: true })
		if (httpOk(response)) {
			setSelectedItem({})
			setModalBonusWriteOff(false)
			searchWithFilter()
		}
	}

	async function loadPartnersHelper() {
		const response = await GET('/admin/helper/partners')
		if (httpOk(response)) setPartnersHelper(response.data)
	}

	function toggleModal(bool = false, item = {}) {
		if (bool) {
			item.role = item.role || 'ROLE_PARTNER'
			if (item.phone) {
				const phone = String(item.phone).replace(/\D/g, '')
				item.phone = phone.startsWith('998') && phone.length >= 12
					? phone.substring(3, 12)
					: phone
			}
			// Подставляем проценты из users_partners (список отдаёт percentage / parent_*)
			item.percentage = item.percentage ?? item.partner_percentage ?? ''
			item.parent_percentage = item.parent_percentage ?? ''
			item.parent_id = item.parent_id ?? null
			if (!item.id) loadPartnersHelper()
			setSelectedItem(item)
		} else {
			setSelectedItem({
				'login': '',
				'phone': '',
				'password': '',
				'role': 'ROLE_PARTNER',
				'percentage': '',
				'parent_percentage': '',
				'parent_id': null,
			})
		}

		setModalUser(bool)
	}

	function toggleModalPayment(bool = false, item = {}) {
		setModalPayment(bool)
		setSelectedItem(item)
	}

	/**
	 * Доступ партнёра в кабинеты своих клиентов.
	 *
	 * С этим правом партнёр входит логином клиента и своим паролем — но только на
	 * заведениях, закреплённых за ним. Раньше то же самое делал общий мастер-пароль,
	 * одинаковый для всех и не привязанный ни к партнёру, ни к заведению.
	 */
	async function togglePartnerClientAccess(item) {
		const enabled = !item.has_client_login

		const question = enabled
			? `Разрешить «${item.login}» входить в кабинеты своих клиентов?`
			: `Запретить «${item.login}» входить в кабинеты клиентов?`

		if (!window.confirm(question)) {
			return
		}

		const response = await PUT('/admin/partners/client-access', {
			id: item.id,
			enabled: enabled,
		}, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
		}
	}

	function toggleModalBonus(bool = false, item = {}) {
		setModalBonus(bool)
		setSelectedItem(bool ? { ...item, 'amount': '', 'note': '' } : item)
	}

	function toggleModalBonusWriteOff(bool = false, item = {}) {
		setModalBonusWriteOff(bool)
		setSelectedItem(bool ? { ...item, 'amount': '', 'note': '' } : item)
	}

	function toggleModalPaymentHistory() {
		setPayments([])
	}

	async function toggleModalBonusHistory(item = null, page = 0) {
		if (!item?.login) {
			setModalBonusHistory(false)
			setBonusHistories([])
			setBonusHistoryPagination(prev => ({ ...prev, 'url': '/admin/partner-bonus-histories', 'response': null }))
			return
		}

		const endDate = formatDate(new Date(), 'yyyy-MM-dd')
		const url = `/admin/partner-bonus-histories?partner_login=${encodeURIComponent(item.login)}`
			+ `&start_date=2020-01-01&end_date=${endDate}`
			+ `&size=${BONUS_HISTORY_PAGE_SIZE}&page=${page}`
		const response = await GET(url, {}, { loader: true })
		if (httpOk(response)) {
			setSelectedItem(item)
			setBonusHistories(response.data?.data || [])
			setBonusHistoryPagination(prev => ({ ...prev, 'url': url, 'response': response.data }))
			setModalBonusHistory(true)
		}
	}

	function paginateBonusHistory(page) {
		toggleModalBonusHistory(selectedItem, page)
	}

	function resetFilter() {
		resetToInitialFilters((nextFilterData) => {
			searchWithFilter(nextFilterData)
		})
	}

	function checkFilter(currentFilterData) {
		const hasActiveFilters = !!(
			currentFilterData.search ||
			currentFilterData.page ||
			currentFilterData.balance_positive ||
			currentFilterData.has_card ||
			Number(currentFilterData.size || 20) !== 20 ||
			Number(currentFilterData.status) === -1
		)

		setFilterDataExist(hasActiveFilters)
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handlePageSizeChange(size) {
		const nextFilterData = { ...filterData, size, page: null }
		setFilterData(nextFilterData)
		setPagination(prev => ({ ...prev, size }))
		searchWithFilter(nextFilterData)
	}

	function handlePaginate(page) {
		paginate(page)
		searchWithFilter({ ...filterData, page })
	}

	// Клик по шапке: та же колонка — переворот asc/desc, другая — сортировка по ней с asc
	function handleTableSort(fieldKey) {
		const { field: currentField, sort: currentSort } = parseProductTableOrderBy(filterData.order_by)
		const nextSort = currentField === fieldKey ? (currentSort === 'asc' ? 'desc' : 'asc') : 'asc'
		const order_by = buildProductTableOrderBy(fieldKey, nextSort)

		patchFilterData({ order_by, page: null })
		searchWithFilter({ ...filterData, order_by, page: null })
	}

	function tableSortState() {
		const { field, sort } = parseProductTableOrderBy(filterData.order_by)
		return { order_by: field, sort }
	}

	async function deleteItem() {
		const response = await DELETE('/admin/users/partner', { id: deleteModalParams.id }, { loader: true })
		if (httpOk(response)) {
			setModalDelete(false)
			searchWithFilter()
		}
	}

	// Что именно произойдёт при удалении: партнёра с дочерними сервер не удалит,
	// у остальных снимаются доли на точках, а баланс остаётся под выплату
	function deleteModalMessage() {
		if (deleteModalParams.count_children > 0) {
			return (
				<div>
					<div className="mb-2">
						У партнёра <b>{deleteModalParams.login}</b> есть дочерние партнёры: {deleteModalParams.count_children}.
					</div>
					<div>
						Сначала переведите их к другому родителю — иначе ветка останется без вершины
						и проценты перестанут считаться.
					</div>
				</div>
			)
		}

		return (
			<div>
				<div className="mb-2">
					Удалить партнёра <b>{deleteModalParams.login}</b>?
				</div>
				<div>Он потеряет доступ в кабинет, а начисление бонусов прекратится.</div>
				{deleteModalParams.count_pos > 0 &&
					<div>Будет снят процент с торговых точек: {deleteModalParams.count_pos}.</div>
				}
				{deleteModalParams.balance > 0 &&
					<div>Остаток баланса {formatMoney(deleteModalParams.balance)} сохранится — его ещё можно выплатить.</div>
				}
			</div>
		)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('partners')} [{data.total}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex flex-wrap gap-2 mb-3">
						<div>
							<FilterSearch
								filterData={filterData}
								onSearchChange={(search) => applySearch(search, (nextFilterData) => {
									searchWithFilter(nextFilterData)
								})}>
							</FilterSearch>
						</div>
						<div>
							<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									{t('filter')}
								</Dropdown.Toggle>
								<Dropdown.Menu className="dropdown-filter">
									<div className="row">
										<div className="form-group col-md-12">
											<label>{t('status')}</label>
											<Select
												options={partnerStatuses}
												value={partnerStatuses.find(option => option.id === filterData.status) || partnerStatuses[0]}
												onChange={(option) => setFilterData({
													...filterData,
													status: option ? option.id : 1,
												})}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
										<div className="form-group col-md-12">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="filter_balance_positive"
													checked={!!filterData.balance_positive}
													onChange={(e) => setFilterData({ ...filterData, balance_positive: e.target.checked })} />
												<label className="form-check-label" htmlFor="filter_balance_positive">
													Баланс больше 0
												</label>
											</div>
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="filter_has_card"
													checked={!!filterData.has_card}
													onChange={(e) => setFilterData({ ...filterData, has_card: e.target.checked })} />
												<label className="form-check-label" htmlFor="filter_has_card">
													Есть номер карты
												</label>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end gap-2">
												<button className="btn btn-secondary"
													onClick={() => setDropdownIsOpen(false)}>
													{t('cancel')}
												</button>
												<button className="btn btn-primary"
													onClick={() => applyFilters((nextFilterData) => {
														searchWithFilter(nextFilterData)
													})}>
													{t('apply')}
												</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>
						<div>
							<button className="btn btn-outline-primary btn-wide-2 h-100"
								title="Excel"
								onClick={() => downloadExcel()}>
								<i className="uil uil-file-download-alt"></i>
							</button>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
								{Number(filterData.status) === -1 &&
									<span className="me-2">
										<b>{t('status')}: </b>
										<span>{findKeyFromArrayByValue(partnerStatuses, 'id', filterData.status, 'name')}</span>
									</span>
								}
								{filterData.balance_positive &&
									<span className="me-2">
										<b>Баланс больше 0</b>
									</span>
								}
								{filterData.has_card &&
									<span className="me-2">
										<b>Есть номер карты</b>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '33px' }} className="text-center">ID</th>
									<th style={{ 'width': '20%' }}>{t('login')}</th>
									<th style={{ 'width': '20%' }}>{t('name')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center">{t('phone')}</th>
									<th style={{ 'width': '20%' }} className="text-center">{t('card_number')}</th>
									<th style={{ 'minWidth': '120px' }} className="text-center">{t('date')}</th>
									<th
										style={{ 'width': '10%' }}
										className="text-end th-sortable user-select-none"
										onClick={() => handleTableSort('partner_percentage')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-end gap-1">
											<span>{t('bonus')}</span>
											{renderSortIndicator('partner_percentage', tableSortState())}
										</div>
									</th>
									<th
										style={{ 'width': '10%' }}
										className="text-end th-sortable user-select-none"
										onClick={() => handleTableSort('partner_balance')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-end gap-1">
											<span>{t('balance')}</span>
											{renderSortIndicator('partner_balance', tableSortState())}
										</div>
									</th>
									<th
										style={{ 'width': '10%' }}
										className="text-end th-sortable user-select-none"
										onClick={() => handleTableSort('count_pos')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-end gap-1">
											<span>{t('active')}</span>
											{renderSortIndicator('count_pos', tableSortState())}
										</div>
									</th>
									<th
										style={{ 'width': '10%' }}
										className="text-end th-sortable user-select-none"
										onClick={() => handleTableSort('count_pos_off')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-end gap-1">
											<span>{t('disconnected')}</span>
											{renderSortIndicator('count_pos_off', tableSortState())}
										</div>
									</th>
									<th style={{ 'minWidth': '33px' }} className="text-end"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="text-center"><b>{item.id}</b></td>
										<td className="td-ellipsis">{item.login}</td>
										<td className="td-ellipsis">{item.first_name}</td>
										<td className="text-center">{regexPhoneNumber(item.phone)}</td>
										<td className="text-center">{item.card_number}</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td className="text-end">{formatMoney(item.partner_percentage)}%</td>
										{item.role === "ROLE_PARTNER" && hasPermission('admin_partners_payment') ?
										<td className="text-end text-primary" style={{ cursor: 'pointer' }}
											title="Оплата"
											onClick={() => toggleModalPayment(true, item)}>
											{formatMoney(item.partner_balance)}
										</td>
										:
										<td className="text-end">{formatMoney(item.partner_balance)}</td>
									}
										<td className="text-end">{item.count_pos}</td>
										<td className="text-end">{item.count_pos_off}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														{hasPermission('admin_partners_update') &&
															<div className="table-dropdown-item"
																onClick={() => toggleModal(true, item)}>
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</div>
														}
														{item.role === "ROLE_PARTNER" &&
															<>
																{hasPermission('admin_partners_payment') &&
																	<div className="table-dropdown-item"
																		onClick={() => toggleModalPayment(true, item)}>
																		<i className="uil-edit-alt"></i>
																		Оплата
																	</div>
																}
																{hasPermission('admin_partners_update') &&
																	<div className="table-dropdown-item"
																		onClick={() => togglePartnerClientAccess(item)}>
																		<i className="uil-signin"></i>
																		{item.has_client_login ? 'Запретить вход к клиентам' : 'Разрешить вход к клиентам'}
																	</div>
																}
																{hasPermission('admin_partners_bonus') &&
																	<>
																		<div className="table-dropdown-item"
																			onClick={() => toggleModalBonus(true, item)}>
																			<i className="uil-plus-circle"></i>
																			{t('partner_manual_bonus')}
																		</div>
																		<div className="table-dropdown-item"
																			onClick={() => toggleModalBonusWriteOff(true, item)}>
																			<i className="uil-minus-circle"></i>
																			Списание бонуса
																		</div>
																	</>
																}
																<div className="table-dropdown-item"
																	onClick={() => toggleModalPaymentHistory(item)}>
																	<i className="uil-info-circle"></i>
																	История оплат
																</div>
																<div className="table-dropdown-item"
																	onClick={() => toggleModalBonusHistory(item)}>
																	<i className="uil-bill"></i>
																	{t('admin_partner_bonus_histories')}
																</div>
																{Number(filterData.status) !== -1 && hasPermission('admin_partners_delete') &&
																	<div className="table-dropdown-item text-danger"
																		onClick={() => {
																			setDeleteModalParams({
																				id: item.id,
																				login: item.login,
																				count_children: Number(item.count_children ?? 0),
																				count_pos: Number(item.count_pos ?? 0) + Number(item.count_pos_off ?? 0),
																				balance: Number(item.partner_balance ?? 0),
																			})
																			setModalDelete(true)
																		}}>
																		<i className="uil-times"></i>
																		{t('delete')}
																	</div>
																}
															</>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
							<tfoot>
								<tr>
									<td colSpan="8" className="text-end fw-bold">{t('total')}</td>
									<td className="text-end text-nowrap fw-bold">{formatMoney(data.total_amount)}</td>
									<td className="text-end text-nowrap fw-bold">{data?.status?.total_active ?? 0}</td>
									<td className="text-end text-nowrap fw-bold">{data?.status?.total_not_active ?? 0}</td>
									<td></td>
								</tr>
							</tfoot>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}
							showPageSizeSelect
							pageSizeOptions={PAGE_SIZES}
							onPageSizeChange={handlePageSizeChange}
							marginPagesDisplayed={5}
							pageRangeDisplayed={5}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={modalUser} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<span>{t('create')}</span>
							:
							<span>{t('edit')}</span>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						{!selectedItem.id &&
							<>
								<div className="form-group">
									<label>Родитель (необязательно)</label>
									<Select
										options={partnersHelper}
										value={partnersHelper.find((option) => option.id === selectedItem.parent_id) || null}
										onChange={(option) => setSelectedItem({
											...selectedItem,
											parent_id: option ? option.id : null,
											parent_percentage: option ? (selectedItem.parent_percentage ?? '') : '',
										})}
										placeholder=""
										isClearable
										isSearchable
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => `${option.name} (${option.login})`}
										getOptionValue={(option) => option.id}
									/>
									<div className="form-text text-muted">
										Без родителя — корневой агент. С родителем — суб-агент.
									</div>
								</div>

								{!selectedItem.parent_id &&
									<div className="form-group">
										<label>Процент бонуса</label>
										<input type="number" min="0" max="70" step="0.01" className="form-control" name="percentage"
											value={selectedItem.percentage ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'percentage': e.target.value })} />
									</div>
								}

								{!!selectedItem.parent_id &&
									<>
										<div className="d-flex gap-2">
											<div className="form-group w-100">
												<label>Процент родителю %</label>
												<input type="number" min="0" max="70" step="0.01" className="form-control"
													name="parent_percentage"
													value={selectedItem.parent_percentage ?? ''}
													onChange={(e) => setSelectedItem({ ...selectedItem, 'parent_percentage': e.target.value })} />
											</div>
											<div className="form-group w-100">
												<label>Процент агенту %</label>
												<input type="number" min="0" max="70" step="0.01" className="form-control"
													name="percentage"
													value={selectedItem.percentage ?? ''}
													onChange={(e) => setSelectedItem({ ...selectedItem, 'percentage': e.target.value })} />
											</div>
										</div>
										<div className="form-text text-muted mb-2">
											Сумма не должна превышать доступный кап родителя.
										</div>
									</>
								}
							</>
						}

						{!!selectedItem.id && !selectedItem.parent_id &&
							<div className="form-group">
								<label>Процент бонуса (агент)</label>
								<input type="number" min="0" max="70" step="0.01" className="form-control" name="percentage"
									value={selectedItem.percentage ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'percentage': e.target.value })} />
								<div className="form-text text-muted">Корневой партнёр — один процент (кап ветки).</div>
							</div>
						}

						{!!selectedItem.id && !!selectedItem.parent_id &&
							<>
								<div className="alert alert-light border py-2 mb-3">
									<b>Родитель:</b> #{selectedItem.parent_id}{' '}
									{selectedItem.parent_name || '—'}
									{selectedItem.parent_login ? ` (${selectedItem.parent_login})` : ''}
								</div>
								<div className="d-flex gap-2">
									<div className="form-group w-100">
										<label>Процент родителю %</label>
										<input type="number" min="0" max="70" step="0.01" className="form-control"
											name="parent_percentage"
											value={selectedItem.parent_percentage ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'parent_percentage': e.target.value })} />
									</div>
									<div className="form-group w-100">
										<label>Процент агенту %</label>
										<input type="number" min="0" max="70" step="0.01" className="form-control"
											name="percentage"
											value={selectedItem.percentage ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'percentage': e.target.value })} />
									</div>
								</div>
								<div className="form-text text-muted mb-2">
									Сумма не должна превышать доступный кап родителя.
								</div>
							</>
						}

						<div className="form-group">
							<label>Имя</label>
							<input type="text" className="form-control" name="first_name" value={selectedItem.first_name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'first_name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>Логин</label>
							<input type="text" className="form-control" name="login" value={selectedItem.login ?? ''} disabled={!!selectedItem.id}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'login': regexLogin(e.target.value) })} />
						</div>
						<div className="form-group">
							<label>Телефон</label>
							<div className="input-group">
								<span className="input-group-text">998</span>
								<input type="number" className="form-control" name="phone"
									value={selectedItem.phone ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value })} />
							</div>
						</div>
						<div className="form-group">
							<label>Пароль</label>
							<input type="text" className="form-control" name="password" value={selectedItem.password ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'password': e.target.value })} />
						</div>
						<div className="d-flex w-100 gap-2 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			{/* MODAL PAYMENT*/}
			<Modal show={modalPayment} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalPayment()}>
				<Modal.Header closeButton>
					<Modal.Title>Оплата</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => partnerPayment(e)} autoComplete="off">
						<div className="form-group">
							<label>Баланс</label>
							<input type="text" className="form-control"
								disabled
								value={formatMoneyInput(selectedItem.partner_balance) ?? ''}
								onChange={() => { }} />
						</div>
						<div className="form-group">
							<label>Сумма</label>
							<div className="input-group">
								<input type="text" className="form-control" name="amount"
									value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.-]/g, '') })} />
								<button type="button" className="btn btn-outline-secondary" title="Весь баланс"
									onClick={() => setSelectedItem({ ...selectedItem, 'amount': String(Number(selectedItem.partner_balance ?? 0)) })}>
									<i className="uil-equal-circle"></i>
								</button>
								<button type="button" className="btn btn-outline-secondary" title="Округлить вниз до 50 000"
									onClick={() => setSelectedItem({ ...selectedItem, 'amount': String(Math.floor(Number(selectedItem.partner_balance ?? 0) / 50000) * 50000) })}>
									<i className="uil-arrow-down"></i>
								</button>
							</div>
						</div>
						<div className="form-group">
							<label>Примечание</label>
							<input type="text" className="form-control" name="note" value={selectedItem.note}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div onClick={() => setSelectedItem({ ...selectedItem, 'note': `Оплата бонуса ${formatMoney(selectedItem.amount)}` })}>
							Оплата бонуса
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalPayment()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT*/}

			{/* MODAL BONUS*/}
			<Modal show={modalBonus} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalBonus()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('partner_manual_bonus')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => partnerBonus(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('balance')}</label>
							<input type="text" className="form-control"
								disabled
								value={formatMoneyInput(selectedItem.partner_balance) ?? ''}
								onChange={() => { }} />
						</div>
						<div className="form-group">
							<label>{t('bonus')}</label>
							<input type="text" className="form-control" name="amount"
								value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note" value={selectedItem.note ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalBonus()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!selectedItem.amount || !selectedItem.note}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL BONUS*/}

			{/* MODAL BONUS WRITE OFF*/}
			<Modal show={modalBonusWriteOff} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalBonusWriteOff()}>
				<Modal.Header closeButton>
					<Modal.Title>Списание бонуса</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => partnerBonusWriteOff(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('balance')}</label>
							<input type="text" className="form-control"
								disabled
								value={formatMoneyInput(selectedItem.partner_balance) ?? ''}
								onChange={() => { }} />
						</div>
						<div className="form-group">
							<label>Сумма списания</label>
							<input type="text" className="form-control" name="amount"
								value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note" value={selectedItem.note ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="form-text text-muted">
							Деньги агенту не выдаются — уменьшается только бонусный баланс.
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalBonusWriteOff()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!selectedItem.amount || !selectedItem.note}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL BONUS WRITE OFF*/}

			{/* MODAL PAYMENT HISTORY*/}
			<Modal show={modalPaymentHistory} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalPaymentHistory(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						История
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th className="text-nowrap">{t('date')}</th>
									<th className="text-nowrap">{t('note')}</th>
									<th className="text-nowrap text-center">{t('status')}</th>
									<th className="text-nowrap text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{payments?.map((item, index) => (
									<tr key={index}>
										<td>{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="td-ellipsis" title={item.note}>{item.note}</td>
										<td className="text-center">
											{item.status === 1 &&
												<span className="text-success">Успешно</span>
											}
											{item.status === -2 &&
												<span className="text-danger">Списание</span>
											}
											{item.status === -3 &&
												<span className="text-danger">Перевод</span>
											}
										</td>
										<td className="text-nowrap text-end">{formatMoney(item.amount)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT HISTORY*/}

			{/* MODAL BONUS HISTORY */}
			<Modal show={modalBonusHistory} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalBonusHistory()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem?.first_name || selectedItem?.login || ''}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th className="text-nowrap">{t('date')}</th>
									<th className="text-nowrap">{t('pos')}</th>
									<th className="text-nowrap">{t('note')}</th>
									<th className="text-nowrap text-end">%</th>
									<th className="text-nowrap text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{bonusHistories.map((item, index) => (
									<tr key={item.id || index}>
										<td className="text-nowrap">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="td-ellipsis" title={item.pos_name}>{item.pos_name}</td>
										<td className="td-ellipsis" title={item.note}>{item.note}</td>
										<td className="text-nowrap text-end">{formatMoney(item.partner_percentage)}</td>
										<td className={`text-nowrap text-end ${Number(item.display_amount ?? item.partner_amount) < 0 ? 'text-danger' : ''}`}>
											{formatMoney(item.display_amount ?? item.partner_amount)}
										</td>
									</tr>
								))}
								{!bonusHistories.length &&
									<tr>
										<td colSpan={5} className="text-center text-muted">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</Modal.Body>
				{Number(bonusHistoryPagination?.response?.total || 0) > BONUS_HISTORY_PAGE_SIZE &&
					<Modal.Footer className="justify-content-end">
						<FilterPagination
							pagination={bonusHistoryPagination}
							paginate={paginateBonusHistory}>
						</FilterPagination>
					</Modal.Footer>
				}
			</Modal>
			{/* MODAL BONUS HISTORY */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				message={deleteModalMessage()}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index
